import { render, staticRenderFns } from "./user-rating.vue?vue&type=template&id=31addcae&scoped=true&"
import script from "./user-rating.vue?vue&type=script&lang=js&"
export * from "./user-rating.vue?vue&type=script&lang=js&"
import style0 from "./user-rating.vue?vue&type=style&index=0&id=31addcae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31addcae",
  null
  
)

export default component.exports